import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const GridStyled = styled(Grid)({
  height: '100%',
});
